module.exports = __webpack_public_path__ + "img/finance-a.eb91e690.svg";